import { useContext, useMemo } from 'react';

import { FeatureFlagsContext } from '../../contexts/FeatureFlagsContext';
import { PATH_DASHBOARD_STUDENT, PATH_WIZARD } from '../../routes/paths';
import useAlternatePlarWizardGate from '../useAlternatePlarWizardGate/useAlternatePlarWizardGate';
import userAuth from '../userAuth';

export const useHomepagePath = (): string => {
  const { auth } = userAuth();
  const { features } = useContext(FeatureFlagsContext);
  const { isSubmissionOnly } = useAlternatePlarWizardGate();

  return useMemo(() => {
    if (isSubmissionOnly) {
      return PATH_WIZARD.steps.submission;
    }

    if (!auth?.onBoardingCompleted) {
      return PATH_WIZARD.root;
    }

    if (features?.qsemHomepageByStudentType) {
      const studentType = auth?.student?.studentType?.toLowerCase();
      const studentTypeConfig =
        features.qsemHomepageByStudentType.find(
          (config) => !!studentType && config.type.toLowerCase() === studentType,
        ) ?? features.qsemHomepageByStudentType.find((config) => config.type.toLowerCase() === 'default');

      if (studentTypeConfig) {
        switch (studentTypeConfig.route) {
          case 'careers':
            return PATH_DASHBOARD_STUDENT.admin.occupations;

          case 'careers_goals':
            return PATH_DASHBOARD_STUDENT.admin.occupations;

          case 'learning_paths':
            return PATH_DASHBOARD_STUDENT.admin.LearningPaths;

          case 'home':
            return PATH_DASHBOARD_STUDENT.admin.pageHome;

          default:
            return PATH_DASHBOARD_STUDENT.admin.pageHome;
        }
      }
    }

    return PATH_DASHBOARD_STUDENT.admin.pageHome;
  }, [isSubmissionOnly, auth?.onBoardingCompleted, auth?.student?.studentType, features?.qsemHomepageByStudentType]);
};
